import { ChangeDetectorRef, Component, Input, inject, output, OutputEmitterRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { RecipientsSearchFormValue } from '@app/core/models/recipient.model';

@Component({
	selector: 'recipients-search-form',
	templateUrl: './recipients-search-form.component.html',
	styleUrls: ['./recipients-search-form.component.scss'],
	standalone: false
})
export class RecipientsSearchFormComponent {
	private cdr = inject(ChangeDetectorRef);

	@Input() set formData(val: Partial<RecipientsSearchFormValue>) {
		if (val) {
			this.fillFormWithInitialData(val);
		}
	}
	readonly submit: OutputEmitterRef<RecipientsSearchFormValue> = output<RecipientsSearchFormValue>();

	public readonly NAME_CONTROL_NAME: string = 'recipientName';
	public readonly EMAIL_CONTROL_NAME: string = 'email';
	public readonly ADDRESS_CONTROL_NAME: string = 'address';
	public readonly TAX_ID_CONTROL_NAME: string = 'taxId';

	public formGroup: UntypedFormGroup = new UntypedFormGroup({
		[this.NAME_CONTROL_NAME]: new UntypedFormControl(),
		[this.EMAIL_CONTROL_NAME]: new UntypedFormControl(),
		[this.ADDRESS_CONTROL_NAME]: new UntypedFormControl(),
		[this.TAX_ID_CONTROL_NAME]: new UntypedFormControl()
	});

	private fillFormWithInitialData(data: Partial<RecipientsSearchFormValue>): void {
		Object.keys(data).forEach((key: string) => {
			if (this.formGroup.contains(key)) {
				this.formGroup.get(key).setValue(data[key]);
			}
		});
	}

	private submitForm(): void {
		this.submit.emit(this.formGroup.value);
	}

	public onClearAll(): void {
		this.formGroup.reset();
	}

	public onSubmit(): void {
		if (this.formGroup.valid) {
			this.submitForm();
		} else {
			this.formGroup.markAllAsTouched();
			this.cdr.markForCheck();
		}
	}
}
